import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cash-book',
  templateUrl: './cash-book.component.html',
  styleUrls: ['./cash-book.component.css']
})
export class CashBookComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
